import PropTypes from 'prop-types';

const historyShape = PropTypes.objectOf(
  PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.func, PropTypes.object]),
).isRequired;

export default historyShape;
